// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/common.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Value } from "@bufbuild/protobuf";

/**
 * Pagination request
 *
 * @generated from message omnios.v1.PageRequest
 */
export const PageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PageRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Pagination response metadata
 *
 * @generated from message omnios.v1.PageResponse
 */
export const PageResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PageResponse",
  () => [
    { no: 1, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Flexible JSON-like value stored as JSONB in Postgres
 *
 * @generated from message omnios.v1.JsonValue
 */
export const JsonValue = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.JsonValue",
  () => [
    { no: 1, name: "fields", kind: "message", T: Struct },
  ],
);

/**
 * Sort specification
 *
 * @generated from message omnios.v1.SortSpec
 */
export const SortSpec = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SortSpec",
  () => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "descending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Filter specification (server evaluates against JSONB + indexed columns)
 *
 * @generated from message omnios.v1.Filter
 */
export const Filter = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Filter",
  () => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "op", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value", kind: "message", T: Value },
  ],
);

/**
 * Compound filter
 *
 * @generated from message omnios.v1.FilterGroup
 */
export const FilterGroup = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FilterGroup",
  () => [
    { no: 1, name: "logic", kind: "enum", T: proto3.getEnumType(FilterGroup_Logic) },
    { no: 2, name: "filters", kind: "message", T: Filter, repeated: true },
    { no: 3, name: "groups", kind: "message", T: FilterGroup, repeated: true },
  ],
);

/**
 * @generated from enum omnios.v1.FilterGroup.Logic
 */
export const FilterGroup_Logic = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.FilterGroup.Logic",
  [
    {no: 0, name: "LOGIC_UNSPECIFIED"},
    {no: 1, name: "AND"},
    {no: 2, name: "OR"},
  ],
);

/**
 * Health check (gRPC standard)
 *
 * @generated from message omnios.v1.HealthCheckRequest
 */
export const HealthCheckRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.HealthCheckRequest",
  () => [
    { no: 1, name: "service", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.HealthCheckResponse
 */
export const HealthCheckResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.HealthCheckResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(HealthCheckResponse_ServingStatus) },
  ],
);

/**
 * @generated from enum omnios.v1.HealthCheckResponse.ServingStatus
 */
export const HealthCheckResponse_ServingStatus = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.HealthCheckResponse.ServingStatus",
  [
    {no: 0, name: "SERVING_STATUS_UNSPECIFIED"},
    {no: 1, name: "SERVING"},
    {no: 2, name: "NOT_SERVING"},
  ],
);

